import { Renderer2, Component, OnInit, Input, Inject, OnChanges } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../../service/global.service';
import { GoogleOrgChartInfo } from '../../model/GoogleOrgChartInfo';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { TokenService } from '../../service/token.service';

@Component({
  selector: 'app-google-org-chart',
  templateUrl: './google-org-chart.component.html',
  styleUrls: ['./google-org-chart.component.css']
})
export class GoogleOrgChartComponent implements OnChanges {
  //Passed parameters
  @Input() IsUpdate: string;
  @Input() ProjectCode: string;
  @Input() OrgChartType: string;

  /************************ Variables ****************************/
  baseurl: string = "";
  jsCode: string = "";
  CountListOrgChart: number = 0;
  ListOrgChartInfo: GoogleOrgChartInfo[] = [];

  /************************ Variables ****************************/

  /*********************** Functions *****************************/
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private renderer2: Renderer2
    , @Inject(DOCUMENT) private _document: Document, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }

  ngOnChanges(): void {
    
    this.OnloadBaseline();
    if (this.OrgChartType == "Internal") {
      this.LoadGetGoogleChartOrganizationalData();
    } else {
      this.LoadGetGoogleChartOrganizationalData();
    }
  }

  //Initial Data
  async LoadGetGoogleChartOrganizationalData() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson["ProjectCode"] = this.ProjectCode;
      objectjson["OrganizationalTeamId"] = this.OrgChartType == "Internal" ? 1 : 2;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<GoogleOrgChartInfo[]>(this.baseurl + "Organizational/GetGoogleChartOrganizationalData",
          strjson, httpOptions)
        .toPromise().then(data => {
          if (data.length > 0) {

            this.CountListOrgChart = data.length;
            this.InicialData(data);
          }
        });
    }
  }

  Importjs(src: any): void {

    let script = this.renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = src;

    this.renderer2.appendChild(this._document.body, script);
  }
  OnloadBaseline(flagfirsttime: boolean = true) {
    $('#scriptchart').remove();
      if (flagfirsttime == true) {
            var css = `<style>.google-visualization-tooltip {
          width: unset !IMPORTANT;
          height: unset !IMPORTANT;
      }</style>`;
      $('body').append(css);
        this.Importjs('https://www.google.com/jsapi');
    }
  }


  RenderChart(data: string)
  {
    
    let script = this.renderer2.createElement('script');
    script.setAttribute("id", "scriptorgschart");
    script.type = 'text/javascript';
    script.text = data;

    this.renderer2.appendChild(this._document.body, script);
  }

  InicialData(repo: GoogleOrgChartInfo[]) {
    
    this.jsCode = `
    google.charts.load('current', {packages:["orgchart"]});
    google.charts.setOnLoadCallback(drawChart);

    function drawChart() {
      var data = new google.visualization.DataTable();
		  data.addColumn('string', 'Name');
		  data.addColumn('string', 'Manager');
		  data.addColumn('string', 'ToolTip');

		  var response = `+
        JSON.stringify(repo);

    this.jsCode += `

		    for (var i = 0; i < response.length; i++) {
				    var row = new Array();
				    var empName = response[i].Employee;
				    var mgrName = response[i].Manager;
				    var empID = response[i].empID;
				    var mgrID = response[i].mgrID;
            var empRoleInProject = (response[i].empRoleInProject) ? '<br>(' + response[i].empRoleInProject + ')':'';
            var mgrRoleInProject = (response[i].mgrRoleInProject) ? '<br>(' + response[i].mgrRoleInProject + ')':'';
				    var designation = response[i].designation;

				    data.addRows([[{
					    v: empID + ' - ' + empName + ' ' + empRoleInProject,
					    f: empID + ' - ' + empName + ' ' + empRoleInProject
				    }, mgrID + ' - ' + mgrName + ' ' + mgrRoleInProject, designation]]);
		    }

		    var chart = new google.visualization.OrgChart(document.getElementById('chart_div_` + this.OrgChartType;

      this.jsCode += `' ));
		        chart.draw(data, { allowHtml: true });
        }`;

    

    this.RenderChart(this.jsCode);
  }

}
